export default __webpack_public_path__ + "static/media/recorte_6.477e2255.JPG";